import * as React from 'react';

import {ChartTooltip} from '../chart-tooltip';
import {Directions, PositionParentType} from '../drop-menu/types';

export function TooltipSections(props: {tooltipSections}) {
  return (
    <ChartTooltip positioning={{positionParent: PositionParentType.ParentElement}}>
      <div className={`legend-rollup-segments`}>
        {props.tooltipSections.map(({color, label, tooltipSections}, index) => (
          <div className={`segment-text`} key={index} style={{'--color': color}}>
            {label}
            {tooltipSections?.chartSection ? (
              <ChartTooltip
                direction={Directions.Right}
                positioning={{positionParent: PositionParentType.ParentElement}}
                sections={tooltipSections?.chartSection}
                titleColor={color}
              />
            ) : null}
          </div>
        ))}
      </div>
    </ChartTooltip>
  );
}
